


















































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import {
  hasEmployeeAdministratorAuthority,
  hasManagerAuthority,
  hasFacilitiesOrEmployeeAdministratorAuthority,
} from '@/shared/directive/has-authority.directive';
import TabButton from '@/shared/tab-button.component.vue';
import CardTitle from '@/shared/card/card-title.component.vue';
import Authority from '@/domain/security/authority.entity';
import AuthorityEnum from '@/domain/security/authority.enum';
import AuthorityStore from '@/domain/security/authority.store';
import Assignment from '@/domain/drd/entity/assignment.entity';
import EmployeeTalentLevel from '@/domain/employees/entity/employee-talent-level.entity';
import EmployeeService from '../../../domain/employees/service/employee.service';
import EmployeeApportionmentService from '../../../domain/employees/service/employee-apportionment.service';
import Profile from './employee-profile.component.vue';
import Employee from '../../../domain/employees/entity/employee.entity';
import EmployeeApportionment from '../../../domain/employees/entity/employee-apportionment';
import CareerUpdate from '../../../domain/employees/entity/career-update.entity';
import ProfileMenu from './profile-menu.component.vue';
import HistoryModal from './modal/history-modal.component.vue';
import TabComponent from './tab-components/profile-tabs.component.vue';
import PersonalDataComponent from './tab-components/personal-data/personal-data.component.vue';
import CarrerDataComponent from './tab-components/career-data/carrer-data.component.vue';
import EmployeeActivitiesTableComponent from './tab-components/activities/employee-activities-table.component.vue';
import ProfessionalDataComponent from './tab-components/professional-data/professional-data.component.vue';
import VacationComponent from './tab-components/vacation-payslip/vacation.component.vue';
import ScoreComponent from './tab-components/score/score.component.vue';
import { scoreSource } from './tab-components/score/score-utils';
import SkillMapDataComponent from './tab-components/skill-map-data/skill-map-data.component.vue';
import AllPlansView from './tab-components/all-plans/all-plans.view.vue';
import EmployeeWageComponent from './tab-components/employee-wages/employee-wage.component.vue';
import EmployeeApportionmentComponent from './tab-components/result-center/employee-apportionment.component.vue';

@Component({
  components: {
    TabButton,
    Profile,
    ProfileMenu,
    HistoryModal,
    CardTitle,
    TabComponent,
    PersonalDataComponent,
    CarrerDataComponent,
    EmployeeActivitiesTableComponent,
    ProfessionalDataComponent,
    VacationComponent,
    ScoreComponent,
    SkillMapDataComponent,
    AllPlansView,
    EmployeeWageComponent,
    EmployeeApportionmentComponent,
  },
  directives: {
    hasEmployeeAdministratorAuthority,
    hasManagerAuthority,
    hasFacilitiesOrEmployeeAdministratorAuthority,
  },
})
export default class Employees extends Vue {
  employee: Employee = new Employee({});

  employeeApportionments: EmployeeApportionment[] | null = null;

  employeeApportionmentsKey: number = 0;

  aux: CareerUpdate = new CareerUpdate({});

  showCreate: boolean = false;

  showAlert: boolean = false;

  alertMessage: string = 'Deseja realmente prosseguir? Ao clicar no botão Sim, o evento será imediatamente descartado.';

  deletableUpdate: CareerUpdate = new CareerUpdate({});

  showHistory: boolean = false;

  reset: boolean = false;

  edit: boolean = false;

  key: string = '';

  source = scoreSource.employee

  authority!: Authority;

  isAdministrator: boolean = false;

  isFacilitiesAdministrator: boolean = false;

  accessProfessionalData: boolean = false;

  updateProfessionalData: boolean = false;

  createOrUpdateScore: boolean = false;

  readScore: boolean = false;

  createResignation: boolean = false;

  updateGodfather: boolean = false;

  updateAcompanied: boolean = false;

  updateNeedTraining: boolean = false;

  updateCarrerUpdate: boolean = false;

  createCarrerUpdate: boolean = false;

  createInternalMovement: boolean = false;

  deleteCarrerUpdate: boolean = false;

  deletePastCarrerUpdate: boolean = false;

  readCarrerUpdateHistory: boolean = false;

  readPersonalData: boolean = false;

  isManager: boolean = false;

  readEmployeeRemunaration: boolean = false;

  readEmployeeActivity: boolean = false;

  isSubordinate: boolean = false;

  isEmployeeAdministrator: boolean = false;

  isPersonalDepartament: boolean = false;

  isBusinessPartner: boolean = false;

  isEmployeeApportionment: Boolean = false;

  updateNeedTrainning: boolean = false;

  hasUpdatePastCareerUpdateEvent: boolean = false;

  hasAccessSkillMapTab: boolean = false;

  hasCreatePdiPlan: boolean = false;

  hasUpdatePdiPlan: boolean = false;

  hasDeletePdiPlan: boolean = false;

  hasAccessPdiTab: boolean = false;

  hasUpdateReceiveCommission: boolean = false;

  hasAccessPayslip: boolean = false;

  loggedUserEmail: string = '';

  assignment: Assignment = new Assignment();

  sortBy: Array<string> = ['assignment.role.name'];

  sortDesc: boolean[] = [false];

  performanceDescriptionId: string = '';

  pagination: any = {
    itemsPerPage: 10,
    page: 1,
    sortBy: this.sortBy,
    sortDesc: this.sortDesc,
    total: 0,
    pageCount: 0,
  }

  talentLevel: EmployeeTalentLevel = new EmployeeTalentLevel({});

  showTalentLevel: boolean = false;

  isOtherGroup: boolean = false;

  isInternalMovementResponsible: boolean = false;

  currentCareerUpdate: CareerUpdate = new CareerUpdate({});

  updateEmployeeApportionment: boolean = false;

  back() {
    window.history.go(-1);
  }

  go(value: string) {
    return this.$router.push(value);
  }

  get isLoggedUserProfile(): boolean {
    return this.employee.availableEmails.some(
      (email: string) => email.toLowerCase() === this.loggedUserEmail,
    );
  }

  async created() {
    this.$destroy();
    await this.getProfile();
    await this.checkIsSubordinate();
    await this.validationAuthorities();
  }

  @Watch('$route.params')
  async getProfile() {
    if (this.$route.params.username) {
      await EmployeeService.getEmployeeByUsername(this.$route.params.username)
        .then((response: Employee) => {
          this.employee = response;
          sessionStorage.setItem('employeId', this.employee.id);
          this.getEmployeeApportionments();
        })
        .catch(error => VbSnackbarService.handleHttpError(error));
    }
  }

  async getEmployeeApportionments() {
    try {
      const result = await EmployeeApportionmentService.getEmployeeApportionments(this.employee.id);
      this.employeeApportionments = Array.isArray(result) ? result : [];
      this.employeeApportionmentsKey += 1;
      this.setIsEmployeeApportionment();
    } catch (error) {
      this.employeeApportionments = [];
      VbSnackbarService.handleHttpError(error);
    }
  }

  async validationAuthorities() {
    this.loggedUserEmail = this.$store.state.email;
    await AuthorityStore.fetchedAuthority().then((authority) => {
      this.authority = authority;
    });
    this.isOtherGroup = this.authority.isOthersGroups();
    this.isAdministrator = this.authority.isAdministrator();
    this.isFacilitiesAdministrator = this.authority.isFacilitiesAdministrator();
    this.isEmployeeAdministrator = this.authority.isEmployeeAdministrator();
    this.isPersonalDepartament = this.authority.isPersonalDepartment();
    this.isBusinessPartner = this.authority.isBusinnesPartner();
    this.accessProfessionalData = this.authority.hasAccessProfessionalData();
    this.updateProfessionalData = this.authority.hasUpdateProfessionalData();
    this.createOrUpdateScore = this.authority.hasCreateOrUpdateEmployeeScore();
    this.readScore = this.authority.hasReadScore();
    this.createResignation = this.authority.hasCreateResignation();
    this.updateGodfather = this.authority.hasUpdateGodfather();
    this.updateAcompanied = this.authority.hasUpdateAcompanied();
    this.updateNeedTraining = this.authority.hasUpdateNeedTraining();
    this.createCarrerUpdate = this.authority.hasCreateCarrerUpdate();
    this.createInternalMovement = this.authority.hasCreateInternalMovement();
    this.updateCarrerUpdate = this.authority.hasUpdateCarrerUpdate();
    this.deleteCarrerUpdate = this.authority.hasDeleteCarrerUpdate();
    this.deletePastCarrerUpdate = this.authority.hasDeletePastCarrerUpdate();
    this.readCarrerUpdateHistory = this.authority.hasReadCarrerUpdateHistory();
    this.readPersonalData = this.authority.hasReadPersonalData();
    this.isManager = this.authority.isManager();
    this.readEmployeeRemunaration = this.authority.hasReadEmployeeRemunaration();
    this.readEmployeeActivity = this.authority.hasReadEmployeeActivity();
    this.updateNeedTrainning = this.authority.hasUpdateNeedTraining();
    this.hasUpdatePastCareerUpdateEvent = this.authority.hasUpdatePastCareerUpdateEvent();
    this.hasAccessSkillMapTab = this.authority.isSkillMapTab();
    this.hasCreatePdiPlan = this.authority.hasCreatePdiPlan();
    this.hasUpdatePdiPlan = this.authority.hasUpdatePdiPlan();
    this.hasDeletePdiPlan = this.authority.hasDeletePdiPlan();
    this.hasAccessPdiTab = this.authority.hasAccessPdiTab();
    this.hasUpdateReceiveCommission = this.authority.hasUpdateReceiveCommission();
    this.hasAccessPayslip = this.authority.hasAccessPayslip();
    this.isInternalMovementResponsible = this.authority.isInternalMovementResponsible();
    this.updateEmployeeApportionment = this.authority.hasAuthorities(
      [AuthorityEnum.UPDATE_EMPLOYEE_APPORTIONMENT],
    );
  }

  async checkIsSubordinate() {
    await EmployeeService.getAllSubordinates().then((response) => {
      this.isSubordinate = response.includes(this.employee.id);
    });
  }

  get isTechSubordinate(): boolean {
    return this.employee.techLeadAvailableEmails.includes(this.loggedUserEmail);
  }

  setIsEmployeeApportionment() {
    this.isEmployeeApportionment = (
      this.isLoggedUserProfile
      || (this.employeeApportionments !== null && this.employeeApportionments.length > 0)
    )
  }

  async removeEmployeeApportionment() {
    try {
      const responseEmployeeApportionment = await EmployeeApportionmentService
        .saveEmployeeApportionment(
          this.employee.id,
          [],
        );
      this.employeeApportionments = responseEmployeeApportionment;
      this.employeeApportionmentsKey += 1;
      VbSnackbarService.showSuccess('Rateios removidos com sucesso.');
    } catch (error) {
      VbSnackbarService.handleHttpError(error);
    } finally {
      this.setIsEmployeeApportionment();
    }
  }

  get checkAccessScore(): boolean {
    return (this.readScore && this.isSubordinate)
    || (this.readScore && !this.isOnlyManager)
  }

  get checkAccessPersonalData(): boolean {
    return this.isLoggedUserProfile
    || (this.readPersonalData && this.isFacilitiesAdministrator)
    || (this.readPersonalData && this.isSubordinate)
    || (this.readPersonalData && !this.isOnlyManager)
  }

  get checkAccessProfessionalData(): boolean {
    return (this.accessProfessionalData && this.isSubordinate)
    || (this.accessProfessionalData && this.isTechSubordinate)
    || (this.accessProfessionalData && !this.isOnlyManager)
  }

  get checkAccessEmployeeRemunaration(): boolean {
    return this.isLoggedUserProfile
    || (this.readEmployeeRemunaration && this.isSubordinate)
    || (this.readEmployeeRemunaration && !this.isOnlyManager)
  }

  get checkAccessCommission(): boolean {
    return !this.isLoggedUserProfile
    && ((this.hasUpdateReceiveCommission && this.isSubordinate)
    || (this.hasUpdateReceiveCommission && !this.isOnlyManager))
  }

  get checkAccessEmployeeActivity(): boolean {
    return this.isLoggedUserProfile
    || (this.readEmployeeActivity && this.isSubordinate)
    || (this.readEmployeeActivity && this.isTechSubordinate)
    || (this.readEmployeeActivity && !this.isOnlyManager)
  }

  get checkAccessPayslip(): boolean {
    return this.isLoggedUserProfile
    || (this.hasAccessPayslip && this.isSubordinate)
    || (this.hasAccessPayslip && this.isOtherGroup);
  }

  hasReadScore(): boolean {
    return this.authority.hasAuthorities([AuthorityEnum.READ_SCORE]);
  }

  get checkAccessUpdateNeedTraining(): boolean {
    return (this.updateNeedTrainning && this.isSubordinate)
    || (this.updateNeedTrainning && !this.isOnlyManager);
  }

  get checkAccessUpdateAcompanied(): boolean {
    return (this.isSubordinate && this.updateAcompanied)
    || (this.updateAcompanied && !this.isOnlyManager);
  }

  get checkAccessUpdateGodfather(): boolean {
    return (this.isSubordinate && this.updateGodfather)
    || (this.updateGodfather && !this.isOnlyManager);
  }

  get checkAccessCreateResignation(): boolean {
    return (this.createResignation && this.isSubordinate)
    || (this.createResignation && !this.isOnlyManager);
  }

  get checkAccessCreateCareerUpdate(): boolean {
    return ((this.createCarrerUpdate && this.isSubordinate)
    || (this.createCarrerUpdate && !this.isOnlyManager))
    && !this.isLoggedUserProfile;
  }

  get checkAccessCreateInternalMovement(): boolean {
    return ((this.createInternalMovement && this.isSubordinate)
    || (this.createInternalMovement && (!this.isOnlyManager
      || this.isInternalMovementResponsible)))
    && !this.isLoggedUserProfile;
  }

  get checkAccessReadUpdateHistory(): boolean {
    return (this.readCarrerUpdateHistory && this.isSubordinate)
    || (this.readCarrerUpdateHistory && !this.isOnlyManager)
  }

  get unlockDeleteCareerUpdate(): boolean {
    return ((this.deleteCarrerUpdate && this.isSubordinate)
    || (this.deleteCarrerUpdate && !this.isOnlyManager))
    && !this.isLoggedUserProfile;
  }

  get unlockDeletePastCareerUpdate(): boolean {
    return ((this.deletePastCarrerUpdate && this.isSubordinate)
    || (this.deletePastCarrerUpdate && !this.isOnlyManager))
    && !this.isLoggedUserProfile;
  }

  get unlockUpdateCareerUpdate(): boolean {
    return ((this.updateCarrerUpdate && this.isSubordinate)
    || (this.updateCarrerUpdate && !this.isOnlyManager))
    && !this.isLoggedUserProfile;
  }

  get updatePastCareerUpdateEvent(): boolean {
    return ((this.hasUpdatePastCareerUpdateEvent && this.isSubordinate)
    || (this.hasUpdatePastCareerUpdateEvent && !this.isOnlyManager))
    && !this.isLoggedUserProfile;
  }

  get checkAccessSkillTab(): boolean {
    return this.isLoggedUserProfile
    || (this.hasAccessSkillMapTab && this.isSubordinate)
    || (this.hasAccessSkillMapTab && this.isTechSubordinate)
    || (this.hasAccessSkillMapTab && !this.isOnlyManager)
  }

  get checkAccessPdiTab(): boolean {
    return this.isLoggedUserProfile
    || (this.hasAccessPdiTab && this.isSubordinate)
    || (this.hasAccessPdiTab && this.isTechSubordinate)
    || (this.hasAccessPdiTab && !this.isOnlyManager);
  }

  get checkUpdatePdiPlan(): boolean {
    return this.isLoggedUserProfile
    || (this.hasUpdatePdiPlan && this.isSubordinate)
    || (this.hasUpdatePdiPlan && !this.isOnlyManager)
  }

  get checkDeletePdiPlan(): boolean {
    return (this.hasDeletePdiPlan && this.isSubordinate)
    || (this.hasDeletePdiPlan && !this.isOnlyManager)
  }

  get isOnlyManager(): boolean {
    return this.isManager && !(this.isBusinessPartner
        || this.isPersonalDepartament
        || this.isAdministrator)
  }

  get checkUpdateEmployeeApportionment(): boolean {
    return (this.updateEmployeeApportionment && this.isSubordinate)
    || (this.updateEmployeeApportionment && !this.isOnlyManager);
  }

  setCurrentCareerUpdate(careerUpdate: CareerUpdate) {
    this.currentCareerUpdate = careerUpdate;
  }
}
